import { createFileRoute } from '@tanstack/react-router'

import { validateListSearch } from '#/shared/lib/list-search'

import { TeamsPage } from '#/modules/teams/teams-page'

export const Route = createFileRoute('/_shell/teams/')({
  component: TeamsPage,
  validateSearch: validateListSearch,
})
